import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Right: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowWall2Right"><Path d="M14.75 7.25L19.5 12L14.75 16.75" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 12H18.75" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowWall2Right;
